import { createContext, useContext, useReducer, useState } from "react";
import {
	IMAGE_RESOURCES_REDUCER_CREATE,
	IMAGE_RESOURCES_REDUCER_DELETE,
	IMAGE_RESOURCES_REDUCER_GET,
} from "../common/constants";
import { ImageResourcesReducer } from "../Reducers/ImageResourcesReducer";
import { LoadingContext } from "./LoadingContext";

export const ImageResourcesContext = createContext();

const ImageResourcesContextProvider = (props) => {
	const [imageResources, setImageResourcesDispatch] = useReducer(ImageResourcesReducer, []);

	const { loadingData, setLoadingData } = useContext(LoadingContext);

	const createDispatchMiddleware = (type, dispatch, successCb, failedCb, others = {}) => {
		setLoadingData({
			is_loading: true,
			message: "Loading property data...",
		});

		dispatch({
			type,
			...others,
			dispatch,
			successCb,
			failedCb,
			loading: true,
			loadingCb: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
			},
		});
	};

	const getAllImageResources = (successCb = () => {}, failedCb = () => {}) => {
		createDispatchMiddleware(
			IMAGE_RESOURCES_REDUCER_GET,
			setImageResourcesDispatch,
			successCb,
			failedCb
		);
	};

	const uploadImageResource = (data, successCb = () => {}, failedCb = () => {}) => {
		createDispatchMiddleware(
			IMAGE_RESOURCES_REDUCER_CREATE,
			setImageResourcesDispatch,
			successCb,
			failedCb,
			{ data }
		);
	};

	const deleteImageResource = (id, successCb = () => {}, failedCb = () => {}) => {
		createDispatchMiddleware(
			IMAGE_RESOURCES_REDUCER_DELETE,
			setImageResourcesDispatch,
			successCb,
			failedCb,
			{ id }
		);
	};

	return (
		<ImageResourcesContext.Provider
			value={{
				imageResources,
				getAllImageResources,
				uploadImageResource,
				deleteImageResource,
			}}
		>
			{props.children}
		</ImageResourcesContext.Provider>
	);
};

export default ImageResourcesContextProvider;
